import { Component, OnInit, Input, EventEmitter, Output, ViewChildren, QueryList, ElementRef, ViewChild, OnDestroy, Renderer2 } from '@angular/core';
import { QuestionnaireModel, AnswerModel, CreateModel, Option, QuestPage, QuestElement, ModeQuestion, GapFill } from '../../models';
import { HttpService, CoreService } from '../../services';
import { DialogService } from '../../dialog';
import { MatchingQuestionComponent } from '../QuestionType';
import * as _ from 'lodash';
import { trigger, transition, style, animate, keyframes, state } from '@angular/animations';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['../questionnaire.component.css'],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            animate('.25s ease-in-out', keyframes([
              style({ top: '{{zoomPosStartY}}', left: '{{zoomPosStartX}}', transform: 'scale(0) translateX(0px)' }),
              style({ top: '{{zoomPosEnd}}', left: '50%', transform: 'scale(1) translateX(-50%)' }),
            ]))
          ]),
        transition(
          ':leave',
          [
            animate('.25s ease-in-out', keyframes([
              style({ top: '{{zoomPosEnd}}', left: '50%', transform: 'scale(1) translateX(-50%)' }),
              style({ top: '{{zoomPosStartY}}', left: '{{zoomPosStartX}}', transform: 'scale(0) translateX(0px)' })
            ]))
          ]),
      ]
    )
  ]




})

export class QuestionnaireComponent implements OnInit, OnDestroy {

  // #region Constructor
  constructor(
    protected indParam: CoreService,
    protected service: HttpService,
    protected dialogservice: DialogService,
    protected renderer: Renderer2
  ) { }
  // #endregion

  // #region Variable globale
  questionnaire: QuestionnaireModel = new QuestionnaireModel;
  answerModel: AnswerModel;
  identQuestionnaire: string = '0';
  modelCreate: CreateModel = new CreateModel;
  model: string;
  resultQuestionnaire: string;
  firstPage: boolean = true;
  // questionnaire modifiable ou non
  readOnly: boolean;
  hint: boolean = false;
  gapFillIndex: number = 0;
  isEmail: boolean = false;
  showFooter: boolean = true;
  isElearning: boolean = false;
  ModeQuestion = ModeQuestion;
  noQuest: boolean = false;
  ModeQuestionnaire: string;

  currentPage: number;

  firstInitMatching: boolean;

  certificationEnded: boolean = false;

  mediaZoomInPath: string = '';
  mediaZoomIn: boolean = false;
  zoomPosStartX: string;
  zoomPosStartY: string;
  zoomPosEnd: string;
  zoomMaxWidth: string;

  @ViewChildren('timerBar') timerBar: QueryList<ElementRef>;
  @ViewChildren('timerTxt') timerTxt: QueryList<ElementRef>;
  @ViewChildren('matching') MatchingElement: QueryList<MatchingQuestionComponent>;

  // #endregion

  // #region Listener
  @Input()
  set inputAnswerModel(value: AnswerModel) {
    if (value != null) {
      this.answerModel = value;
      this.isElearning = this.answerModel.lessonId ? true : false;
      this.isEmail = this.answerModel.isEmailing;
      this.firstPage = true;
      this.ModeQuestionnaire = value.modeQuestionnaire;
      this.initData();
    }
  }

  @Input()
  set idQuestionnaire(value: string) {
    if (value != null) {
      this.identQuestionnaire = value;
    }
  }

  @Input()
  set ShowFooter(value: boolean) {
    this.showFooter = true;
    if (value != null) {
      this.showFooter = value;
    }
  }

  @Output() GetResult: EventEmitter<string> = new EventEmitter<string>();



  @ViewChild('MediaZoomIn') MediaZoomInEl: ElementRef;
  @ViewChild('MediaZoomInImage') MediaZoomInImg: ElementRef;


  // #endregion

  // #region Life Cycle

  /*
 pass AnswerModel with following property :
 stageId : Id du stage du questionnaire
 learnerId : Id du stagiaire que repond au questionnaire
 modelType : Type du questionnaire (exemple : Ques1PRO)
 modelName : Nom du model XML du questionnaire quand le dossier des Models
 */

  ngOnInit(): void {
    this.answerModel = new AnswerModel();
    this.currentPage = 1;
    this.firstInitMatching = true;
  }



  ngOnDestroy(): void {
    this.stopCountDown();
  }


  // #endregion

  // #region public function
  // gestion des radio button
  onSelectionChange(pAnswer: Option, pAnswers: Array<Option>): void {
    pAnswers.forEach((element: Option) => {
      element.answer = '';
    });
    pAnswer.answer = 'true';
  }

  // #region Navigation
  /*----- navigation des les pages du questionnaire -----*/

  pagePlus(pIndex: number, savePage: boolean = false, pPage?: QuestPage): void {
    this.mediaZoomIn = false;
    const ok: boolean | void = (pPage) ? this.checkRequiredQuestion(pIndex, pPage) : true;
    if (ok) {
      $(`#${this.identQuestionnaire}page${pIndex}`).hide();
      pIndex = pIndex + 1;
      this.currentPage = pIndex;
      $(`#${this.identQuestionnaire}page${pIndex}`).show();
      // evite de reafficher la premiere page
      this.firstPage = false;

      if (this.answerModel.questionnaireModel.certification.isCertification && savePage && !this.readOnly && this.ModeQuestionnaire !== 'trainer') {
        this.certificationSaveData(pIndex - 2)
      }
    } else { }


    this.initMatchingQuest(pIndex);
  }

  pageMoins(pIndex: number): void {
    this.mediaZoomIn = false;
    $(`#${this.identQuestionnaire}page${pIndex}`).hide();
    pIndex = pIndex - 1;
    this.currentPage = pIndex;
    $(`#${this.identQuestionnaire}page${pIndex}`).show();
    this.initMatchingQuest(pIndex);
  }



  showFirstPage(): void {
    if (this.firstPage) {
      if (this.answerModel?.questionnaireModel?.certification?.questOngoing && this.answerModel?.questionnaireModel?.certification?.isCertification) {
        this.pagePlus(this.answerModel.questionnaireModel.certification.currentPage);
        this.startCountDown();
      } else {
        if ((this.ModeQuestionnaire === 'EL' || this.ModeQuestionnaire === 'EXO') && this.currentPage > 0) {
          $(`#${this.identQuestionnaire}pageFin`).hide();
          if (this.answerModel?.questionnaireModel?.certification?.isCertification) {
            $(`#${this.identQuestionnaire}page0`).show();
            if ($('#description').text().length == 0) {
              $('#description').append(this.questionnaire.description);
            }
          }
          else {
            $(`#${this.identQuestionnaire}page0`).hide();
            $(`#${this.identQuestionnaire}page1`).show();
            this.initMatchingQuest(1);
          }

        } else {
          $(`#${this.identQuestionnaire}page0`).show();
        }
      }
    }
  }

  showHint(pIndex: number, pElement: Element): void {
    if (!$(`#${this.identQuestionnaire}correct${pIndex}`).hasClass('hintBoxShow')) {
      $(`#${this.identQuestionnaire}correct${pIndex}`).addClass('hintBoxShow');
      setTimeout(() => {
        $(`#${this.identQuestionnaire}correct${pIndex}`).removeClass('hintBoxShow');
      }, 3000);
    }
  }

  // #endregion

  // check if required question are completed
  checkRequiredQuestion(pIdPage: number, pPage: QuestPage): boolean {
    // if (pPage) {
    if (!this.readOnly) {
      let questionIndex: number = 0;
      let missing: number = 0;
      pPage.elements.forEach((element: QuestElement) => {
        let checked: boolean = true;
        if (element.required) {
          checked = false;

          if (!element.text && element.options.length == 0) {
            checked = true;
          } else {

            switch (element.optionType) {
              case '-1': break;

              case 'GAPFILL':
              case 'DOMINO':
                element.options.forEach((option: Option) => {
                  option.gapsFill.forEach((gap: GapFill) => {
                    if (gap.answer) {
                      checked = true;
                    }
                  });
                });
                break;

              default:
                element.options.forEach((option: Option) => {
                  if (option.answer) {
                    checked = true;
                  }
                });
                break;
            }
          }
        }
        // highlight uncompleted question
        if (!checked) {
          missing++;
          $(`#${this.identQuestionnaire}element${pIdPage - 1}${questionIndex}`).addClass('required');
        } else {
          $(`#${this.identQuestionnaire}element${pIdPage - 1}${questionIndex}`).removeClass('required');
        }
        questionIndex++;
      });

      // prevent page change or validation if not all required question are completed
      if (missing === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  // validation by trainer
  correct(): void {
    this.dialogservice.showSplash(true);

    const answerModelSend: AnswerModel = _.cloneDeep(this.answerModel);
    answerModelSend.questionnaireModel = _.cloneDeep(this.questionnaire);



    answerModelSend.Mode = 'correction';
    this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/`, answerModelSend).subscribe((data: AnswerModel) => {
      if (!data.HasError) {
        this.GetResult.emit('');
        this.dialogservice.showSplash(false);
      }
    });
  }


  certificationSaveData(numPage: number = -1) {
    if (!this.answerModel.questionnaireModel.certification.isCertification || numPage == -1)
      this.dialogservice.showSplash(true);

    const answerModelSend: AnswerModel = _.cloneDeep(this.answerModel);
    answerModelSend.questionnaireModel = _.cloneDeep(this.questionnaire);
    //Sauvegarde page par page

    answerModelSend.questionnaireModel.pagination = numPage >= 0 ? [this.answerModel.questionnaireModel.pagination[numPage]] : answerModelSend.questionnaireModel.pagination;
    this.startCountDown();

    answerModelSend.Mode = 'send';
    this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/`, answerModelSend).subscribe((data: AnswerModel) => {
      if (!data.HasError) {
        this.answerModel.questionnaireModel.certification.idSavedQuestionnaire = data.questionnaireModel.certification.idSavedQuestionnaire;
        this.dialogservice.showSplash(false);
      }
    });
  }


  finQuestionnaire(): void {
    this.GetResult.emit(this.resultQuestionnaire);
  }

  // questionnaire validation
  finish(pIdPage: number, pPage: QuestPage): void {
    this.dialogservice.showSplash(true);
    this.mediaZoomIn = false;
    if (this.checkRequiredQuestion(pIdPage, pPage)) {
      this.stopCountDown();
      this.answerModel.questionnaireModel.certification.certificationEnd = true;

      if (!(this.ModeQuestionnaire === 'EL' || this.ModeQuestionnaire === 'EXO')) {
        $(`#${this.identQuestionnaire}page${pIdPage}`).hide();
        $(`#${this.identQuestionnaire}pageFin`).show();
      }
      this.answerModel.questionnaireModel = this.questionnaire;
      this.answerModel.Mode = 'send';
      this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/`, this.answerModel).subscribe((data: AnswerModel) => {
        if (!data.HasError) {
          this.dialogservice.showSplash(false);
          this.resultQuestionnaire = data.etatQuestionnaire;
          if (this.ModeQuestionnaire === 'EL' || this.ModeQuestionnaire === 'EXO') {
            this.finQuestionnaire();
          }
        } else { }
      });
    } else {
      this.dialogservice.showSplash(false);
    }
  }

  finishCertification(): void {
    this.dialogservice.showSplash(true);
    this.mediaZoomIn = false;
    this.answerModel.questionnaireModel.certification.certificationEnd = true;
    this.answerModel.questionnaireModel = this.questionnaire;
    this.answerModel.Mode = 'send';
    this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/`, this.answerModel).subscribe((data: AnswerModel) => {
      this.dialogservice.showSplash(false);
      if (!data.HasError) {
        this.dialogservice.showSplash(false);
        this.resultQuestionnaire = data.etatQuestionnaire;
        this.finQuestionnaire();
      }
    });
  }

  // Pour valider un module EL depuis un questionnaire de validation (car impossible de refaire le questionnaire)
  validModuleELAfterCertif(): void {
    this.resultQuestionnaire = 'FINCERTIF';
    this.finQuestionnaire();
  }


  mediaImgZoomIn(event: any, mediaPath: string): void {
    this.mediaZoomIn = false;
    event.preventDefault();
    this.mediaZoomInPath = mediaPath;

    var img = new Image();
    img.src = mediaPath;

    img.addEventListener("load", (evt: any) => {
      let imgH = evt.srcElement.height < 300 ? 300 : evt.srcElement.height;
      let imgW = evt.srcElement.width < 300 ? 300 : evt.srcElement.width;
      imgW = imgW > window.innerWidth ? window.innerWidth - 30 : imgW;
      this.zoomMaxWidth = `${imgW}px`;
      let failSafe: number = 0;
      let child: any = event.target;
      let scroll: number = 0;
      while (true) {
        scroll += child.scrollTop;
        failSafe++;
        if (failSafe > 100 || child.tagName == 'BODY') {
          if (scroll == 0) {
            scroll = window.scrollY;
          }
          break;
        } else {
          child = child.parentNode;
        }
      }
      const imgEl = event.target.previousSibling;
      let posY: number = imgEl.getBoundingClientRect().top + imgEl.getBoundingClientRect().height / 2 - imgH / 2 + scroll;
      let posX: number = imgEl.getBoundingClientRect().left + imgEl.getBoundingClientRect().width / 2 - imgW / 2;


      this.zoomPosStartX = `${posX}px`;
      this.zoomPosStartY = `${posY}px`;
      this.zoomPosEnd = `${posY < 5 ? 5 : posY}px`;

      this.mediaZoomIn = true;
    });
  }

  closeMediaZoomIn() {
    this.mediaZoomIn = false;
  }

  inOutAnimationDoneEvent(event: any) {
    if (this.MediaZoomInEl)
      this.MediaZoomInEl.nativeElement.setAttribute('style', `top:${this.zoomPosEnd};left:50%; transform:scale(1) translateX(-50%)`);
    this.MediaZoomInImg.nativeElement.setAttribute('style', `max-width:${this.zoomMaxWidth}`);
  }


  // #endregion

  // #region private function
  private initData(): void {
    this.dialogservice.showSplash(true);
    this.mediaZoomIn = false;
    // recuperation des données du questionnaire en cours
    if (this.ModeQuestionnaire === 'visualisation') {
      this.questionnaire = this.answerModel.questionnaireModel;
      this.readOnly = this.answerModel.readOnly;
      // get initial state of the questionnaire
      this.modelCreate.nbElement = this.answerModel.nbElement;
      this.modelCreate.questionnaireModel = new QuestionnaireModel();
      this.modelCreate.questionnaireModel = this.questionnaire;
      this.dialogservice.showSplash(false);
    } else {
      this.answerModel.Mode = 'load';
      this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/`, this.answerModel).subscribe((data: AnswerModel) => {
        if (!data.HasError) {

          if (data.HasAlert) {
            switch (data.Alert) {
              case "Certification terminée":
                this.certificationEnded = true;
                break;


            }
          }

          // console.log(data.questionnaireModel);
          //console.log(data.questionnaireModel.certification);

          if (data.questionnaireModel.certification.timed && data.questionnaireModel.certification.timeUp) {
            // console.log("time up");
            this.noQuest = data.questionnaireModel.ident == "0"
            this.answerModel = data;
            this.questionnaire = data.questionnaireModel;
            this.readOnly = true;
            this.dialogservice.showSplash(false);
          } else {
            this.noQuest = data.questionnaireModel.ident == "0"
            this.answerModel = data;
            this.questionnaire = data.questionnaireModel;
            this.readOnly = data.readOnly;

            this.service.getHttp<AnswerModel>(`${this.indParam.AppParams.apiUrl}api/questionnaire/reseauxSociaux/0/`).subscribe(
              (reseauxSociaux: AnswerModel) => {
                this.answerModel.facebookLink = reseauxSociaux.facebookLink;
                this.answerModel.googlePlusLink = reseauxSociaux.googlePlusLink;
                this.answerModel.linkedInLink = reseauxSociaux.linkedInLink;
                this.answerModel.twitterLink = reseauxSociaux.twitterLink;
                this.answerModel.viadeoLink = reseauxSociaux.viadeoLink;
              });
            this.dialogservice.showSplash(false);
          }
          this.initCkTxt();
        }
      });
    }
  }

  private initCkTxt() {
    setTimeout(() => {
      $('#messageFin').empty();
      $('#description').empty();

      $('#messageFin').append(this.questionnaire.messageFin);
      $('#description').append(this.questionnaire.description);

    }, 10);
  }



  // #region countDown
  intervalCountDown: any;
  distance: number;
  countDown: any = { day: 0, hour: 0, minute: 0, second: 0 };
  private startCountDown(): void {
    if (this.questionnaire.certification.timed && !this.readOnly && this.ModeQuestionnaire !== 'trainer') {
      const now = new Date().getTime();
      const newDateObj = new Date(now + this.questionnaire.certification.tempsCertification * 1000).getTime();
      const maxdistance = this.questionnaire.certification.maxTempsCertification * 1000;

      if (!this.intervalCountDown) {
        this.intervalCountDown = setInterval(() => {
          if (this.ModeQuestionnaire === 'trainer') {
            clearInterval(this.intervalCountDown);
          } else {
            const now = new Date().getTime();
            this.distance = newDateObj - now;
            this.timerBar.forEach(el => el.nativeElement.style.width = `${100 - ((this.distance * 100) / maxdistance)}%`);
            if (this.distance <= 30000) {
              this.timerTxt.forEach(el => el.nativeElement.classList.add('warningTimer'));
              this.timerBar.forEach(el => el.nativeElement.classList.add('warningTimerBar'));
            }


            const days = Math.floor(this.distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((this.distance % (1000 * 60)) / 1000);
            this.countDown = { day: days, hour: hours, minute: minutes, second: seconds };
            if (this.distance < 0) {
              this.timerTxt.forEach(el => el.nativeElement.classList.remove('warningTimer'));
              this.timerBar.forEach(el => el.nativeElement.classList.remove('warningTimerBar'));
              clearInterval(this.intervalCountDown);
              this.finishCertification();
            }
          }
        }, 500);
      }
    }
  }

  private stopCountDown(): void {
    if (this.intervalCountDown) {
      clearInterval(this.intervalCountDown);
    }
  }
  // #endregion


  initMatchingQuest(pIndex: number) {
    if (this.firstInitMatching) {
      this.MatchingElement.forEach((el: MatchingQuestionComponent) => {
        if (el.pageId == pIndex) {
          el.initMatching();
        }
      });
      this.firstInitMatching = false;
    }
  }
  // #endregion
}
